// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimelineBoxDetail_wrapper__qfvAR","boxInfo":"TimelineBoxDetail_boxInfo__1JAMv","loadMore":"TimelineBoxDetail_loadMore__3wg3y"};